import axios from "axios";

import * as types from "./actionTypes";
import { navigateToReports } from "./navigationActions";
import { beginAjaxCall, ajaxCallError } from "./ajaxStatusActions";
import ResponseStatus from "../utils/responseStatus";
import { showLoadingSpinner, hideLoadingSpinner } from "./loadingSpinnerActions";
import { addHrefWithFileToDownload } from "../utils/commonFunctions";

const downloadReport = (reportId, dispatch, getState) => {
  dispatch(beginAjaxCall());

  if (reportId) {
    dispatch(showLoadingSpinner());
    const { table } = getState();
    const { actionUrl, data } = table;
    const { name } = data.find(i => i.id === reportId);

    axios
      .get(`${actionUrl}/xlsx/${reportId}`, {
        responseType: "blob"
      })
      .then(response => {
        if (ResponseStatus.IsOK(response.status)) {          
          const dateString = new Date().toLocaleDateString();          
          addHrefWithFileToDownload(response.data, `${name}_${dateString}.xlsx`);

          dispatch(hideLoadingSpinner());
        } else {
          dispatch(hideLoadingSpinner());
          dispatch(ajaxCallError());
        }
      })
      .catch(error => {
        dispatch(hideLoadingSpinner());
        dispatch(ajaxCallError());
        throw error;
      });
  }
};

export const downloadReportBySelectedRow = (dispatch, getState) => {
  const { table } = getState();
  const { data } = table;
  const { id } = data.find(i => i.selected);

  downloadReport(id, dispatch, getState);
};

export const downloadReportById = id => (dispatch, getState) => {
  downloadReport(id, dispatch, getState);
};

export const createReport = data => dispatch => {
  dispatch(beginAjaxCall());

  axios
    .post(`report`, data)
    .then(response => {
      if (ResponseStatus.IsCreated(response.status)) {
        dispatch({
          type: types.REPORT_ADD
        });

        dispatch(navigateToReports());
      } else {
        dispatch(ajaxCallError());
      }
    })
    .catch(error => {
      dispatch(ajaxCallError());
      throw error;
    });
};

export const updateReport = data => dispatch => {
  dispatch(beginAjaxCall());

  axios
    .put(`report`, data)
    .then(response => {
      if (ResponseStatus.IsOK(response.status)) {
        dispatch({
          type: types.REPORT_UPDATE,
          data: response.data
        });

        dispatch(navigateToReports());
      } else {
        dispatch(ajaxCallError());
      }
    })
    .catch(error => {
      dispatch(ajaxCallError());
      throw error;
    });
};
